/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Lambdas } from './lambdas';
import { RdsSnapshot } from './rdsSnapshot';
import { EC2Instance } from './eC2Instance';
import { ShadowAccountAMIList } from './shadowAccountAMIList';
import { EC2Volume } from './eC2Volume';
import { Ec2KeyPairs } from './ec2KeyPairs';
import { CloudFormationStack } from './cloudFormationStack';
import { S3Bucket } from './s3Bucket';
import { AWSSecrets } from './aWSSecrets';
import { EC2PlacementGroup } from './eC2PlacementGroup';
import { Network } from './network';
import { RDSInstances } from './rDSInstances';
import { RDSDbSubnet } from './rDSDbSubnet';


export interface AWSResourceInfo { 
    ami_list?: ShadowAccountAMIList;
    dynamodb_table?: Array<string>;
    ec2_instances?: Array<EC2Instance>;
    ec2_volumes?: Array<EC2Volume>;
    ec2_key_pairs?: Array<Ec2KeyPairs>;
    ec2_placement_groups?: Array<EC2PlacementGroup>;
    cloud_formation_stacks?: Array<CloudFormationStack>;
    lambda_triggers?: Array<string>;
    lambdas?: Array<Lambdas>;
    network?: Array<Network>;
    rds_cluster?: Array<RDSInstances>;
    rds_instances?: Array<RDSInstances>;
    rds_snapshot?: Array<RdsSnapshot>;
    rds_subnets?: Array<RDSDbSubnet>;
    s3_buckets?: Array<S3Bucket>;
    aws_secrets?: Array<AWSSecrets>;
}

